import { __url } from '../../absoluteUrls/absoluteUrlTranslations';
import { getNinetyNineHostKey } from '../getHostKeyBySite/getNinetyNineHostKey';

export function asNinetyNineAbsUrl(relativePath: string) {
    return `${__url(getNinetyNineHostKey())}${relativePath}`;
}
